import { render, staticRenderFns } from "./autologin-procedura-contratto.vue?vue&type=template&id=6563d6c2&"
import script from "./autologin-procedura-contratto.vue?vue&type=script&lang=js&"
export * from "./autologin-procedura-contratto.vue?vue&type=script&lang=js&"
import style0 from "./autologin-procedura-contratto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports